module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon8.7d4e288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon8.png
// module id = 4VT2
// module chunks = 0